import React from 'react';
import { motion } from 'framer-motion';

export const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#0F0F11] overflow-hidden">
            {/* Background Ambient Glow */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <motion.div
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [0.3, 0.5, 0.3],
                    }}
                    transition={{
                        duration: 8,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute -top-1/2 -left-1/2 w-full h-full bg-indigo-900/20 blur-[120px] rounded-full"
                />
                <motion.div
                    animate={{
                        scale: [1, 1.5, 1],
                        opacity: [0.2, 0.4, 0.2],
                    }}
                    transition={{
                        duration: 10,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 2
                    }}
                    className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-blue-900/10 blur-[120px] rounded-full"
                />
            </div>

            {/* Central Content */}
            <div className="relative z-10 flex flex-col items-center">
                {/* Logo Animation */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="relative w-24 h-24 mb-12"
                >
                    {/* Abstract Canvas/Card Layers */}
                    <motion.div
                        initial={{ opacity: 0, rotate: -20, x: -10 }}
                        animate={{ opacity: 1, rotate: -12, x: -15 }}
                        transition={{ duration: 1, delay: 0.2 }}
                        className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-2xl border border-white/10 backdrop-blur-sm"
                    />
                    <motion.div
                        initial={{ opacity: 0, rotate: 20, x: 10 }}
                        animate={{ opacity: 1, rotate: 12, x: 15 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="absolute inset-0 bg-gradient-to-bl from-blue-500/20 to-cyan-500/20 rounded-2xl border border-white/10 backdrop-blur-sm"
                    />

                    {/* Main Icon */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, delay: 0.4, type: "spring" }}
                        className="absolute inset-0 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-2xl shadow-xl shadow-indigo-500/30 flex items-center justify-center border border-white/20"
                    >
                        <svg className="w-12 h-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.384-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                        </svg>
                    </motion.div>
                </motion.div>

                {/* Text Scramble/Fade */}
                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-white/70 tracking-tight mb-2"
                >
                    NoteSpace
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.8 }}
                    className="text-white/40 text-sm font-medium tracking-wide uppercase"
                >
                    Initializing Workspace
                </motion.p>

                {/* Loading Bar */}
                <div className="w-48 h-1 bg-white/5 rounded-full mt-8 overflow-hidden">
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: '100%' }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                        className="w-full h-full bg-gradient-to-r from-transparent via-indigo-500 to-transparent opacity-50"
                    />
                </div>
            </div>
        </div>
    );
};
